import { createActionGroup } from '@ngrx/store';
import { BookingProductType } from '@products/models/booking.model';

export const PackageProductBookingActions = createActionGroup({
  source: 'Package Booking',
  events: {
    'Set package product in booking list': (bookingProductTypes: BookingProductType[]) => ({
      bookingProductTypes
    }),
    'Remove package from booking list': (bookingProductTypes: BookingProductType[]) => ({
      bookingProductTypes
    })
  }
});
